import React, { useEffect, useState } from 'react'
import { Tab, Divider, Form } from 'semantic-ui-react'
import useUser from '../../Shared/UserProvider/useUser'
import OptionsForm from './OptionsForm'
import AuditPos from './AuditPos'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { getPointOfSale } from '../../../services/PointOfSale/PointOfSale.service'
import { useNavigate } from 'react-router-dom-v5-compat'
import { isProviderACompany } from '../../../services/Provider/Provider.service'
import AdvancedFilters from '../../Home/AdvancedFilters'
import useBreadcrumb from '../../NavBar/useBreadcrumb'
import { useTranslation } from 'react-i18next'

const AdminMerchant = () => {
    const [t] = useTranslation()
    const {user} = useUser()
    const queryClient = useQueryClient()
    const [selectedPosId, setSelectedPosId] = useState(user.getFirstPosFromLoginContext())
    const {setPaths} = useBreadcrumb()
    const navigate = useNavigate()

    useEffect(() => {
        setPaths([{
            text: t('breadcrumb.home'),
            link: true,
            path: '/',
        }, {
            text: t('breadcrumb.settings'),
            link: false,
            path: '/settings',
        }])
    }, [setPaths, t])

    const {data: selectedPos} = useQuery({
        queryKey: ['pointofsales', selectedPosId],
        queryFn: () => getPointOfSale(selectedPosId),
        enabled: !!selectedPosId,
    })

    const handleSelectedPosChange = (filters) => {
        queryClient.setQueryData(['pointofsales', filters.merchantId], filters.merchantId)
        setSelectedPosId(filters.merchantId)
    }

    return (
      <Tab.Pane>
          <Form>
              {(isProviderACompany(user.provider) || user.isLoggedInOwnScope) && (
                <>
                    <AdvancedFilters
                      filters={{
                          merchantId: selectedPosId,
                      }}
                      debounceTimeInMs={0}
                      onFiltersChange={handleSelectedPosChange}
                    >
                        <AdvancedFilters.PosFilter/>
                    </AdvancedFilters>
                    <Divider/>
                </>
              )}

              {selectedPos && (
                <OptionsForm
                  key={selectedPos.id}
                  pointOfSale={selectedPos}
                  onPickingPathClick={() => {
                      navigate('/settings/merchant/picking-path')
                  }}
                />
              )}

              {user.isAdmin() && selectedPos && (
                <AuditPos pos={selectedPos}/>
              )}
          </Form>
      </Tab.Pane>
    )
}

export default AdminMerchant
